import React, { useEffect } from 'react';
import { IItemForGetShortInfo, IItemForGetShortDishInfo, IGetDishesShort } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getDishesShortBySubCategoryIdV2 } from 'backend/dishes';
import { MultipleSelect } from './MultipleSelect';
import style from './index.module.scss';

interface IProps {
	setFetchedCategories: (value: IItemForGetShortInfo[]) => void;
	setFetchedSuggestedDishSubCategories: (value: IItemForGetShortInfo[]) => void;
	setFetchedSuggestedDishes: (value: IItemForGetShortInfo[]) => void;
	setSuggestedDishCategory: (value: Nullable<string>) => void;
	setSuggestedDishSubCategory: (value: Nullable<string>) => void;
	setSuggestedDishes: (value: string[]) => void;
	removeSuggestedDish: (value: string) => void;
	IDsSelectedRestaurant: string[];
	selectedSuggestedDishCategory: Nullable<string>;
	selectedSuggestedDishSubCategory: Nullable<string>;
	fetchedSuggestedDishes: IItemForGetShortDishInfo[];
	selectedSuggestedDishes: string[];
}

export const SuggestedDishMultipleSelect: React.FC<IProps> = React.memo(
	({
		setFetchedCategories,
		setFetchedSuggestedDishSubCategories,
		setFetchedSuggestedDishes,
		setSuggestedDishCategory,
		setSuggestedDishSubCategory,
		setSuggestedDishes,
		removeSuggestedDish,
		IDsSelectedRestaurant,
		selectedSuggestedDishCategory,
		selectedSuggestedDishSubCategory,
		fetchedSuggestedDishes,
		selectedSuggestedDishes,
	}) => {
		const { response, loading, refetch, responseError } = useFetchData<IGetDishesShort, string>(
			selectedSuggestedDishSubCategory ? getDishesShortBySubCategoryIdV2 : null,
			selectedSuggestedDishSubCategory || '',
		);

		useEffect(() => {
			refetch();
		}, [selectedSuggestedDishSubCategory]);

		useEffect(() => {
			if (response) {
				const dishes = response.data.dishes.map((dish) => ({ ...dish, externalId: null }));
				setFetchedSuggestedDishes(dishes);
			}
		}, [response]);

		return (
			<div className={style.container}>
				<div className={style.field}>
					<MultipleSelect
						refetch={refetch}
						setFetchedCategories={setFetchedCategories}
						setFetchedSuggestedDishSubCategories={setFetchedSuggestedDishSubCategories}
						setSuggestedDishCategory={setSuggestedDishCategory}
						setSuggestedDishSubCategory={setSuggestedDishSubCategory}
						setSuggestedDishes={setSuggestedDishes}
						removeSuggestedDish={removeSuggestedDish}
						data={
							selectedSuggestedDishSubCategory && response?.data.dishes && !loading
								? response.data.dishes
								: []
						}
						IDsSelectedRestaurant={IDsSelectedRestaurant}
						selectedSuggestedDishCategory={selectedSuggestedDishCategory}
						selectedSuggestedDishSubCategory={selectedSuggestedDishSubCategory}
						fetchedSuggestedDishes={fetchedSuggestedDishes}
						selectedSuggestedDishes={selectedSuggestedDishes}
						isLoading={loading}
						responseError={responseError}
					/>
				</div>
			</div>
		);
	},
);
